import { useSearchParams } from "react-router";
import BillingRateBuilderMultiStepForm from "./BillingRateBuilderMultiStepForm";
import HrpReconciliationPrototype from "./prototype/HrpReconciliationPrototype";

/** Routes billing-rate-builder to the throwaway reconciliation prototype when ?prototype=reconciliation. */
const BillingRateBuilderRoute = () => {
    const [searchParams] = useSearchParams();
    if (searchParams.get("prototype") === "reconciliation") {
        return <HrpReconciliationPrototype />;
    }
    return <BillingRateBuilderMultiStepForm />;
};

export default BillingRateBuilderRoute;
